import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const ApprovalWorkflowsTab = () => {
  const navigate = useNavigate();

  const approvalTiles = [
    {
      label: 'Purchase Requests',
      iconClass: 'pi pi-shopping-cart',
      link: '/facility/procurement_management/approval_workflows',
      module: 'purchase_requests'
    },
    {
      label: 'Budget Approval',
      iconClass: 'pi pi-dollar',
      link: '/facility/procurement_management/approval_workflows',
      module: 'budgets'
    },
    {
      label: 'Quotation Approval',
      iconClass: 'pi pi-file',
      link: '/facility/procurement_management/approval_workflows',
      module: 'quotation_approval'
    },
    {
      label: 'Expense Approval',
      iconClass: 'pi pi-refresh',
      link: '/facility/procurement_management/approval_workflows',
      module: 'expenses'
    },
    {
      label: 'Purchase Orders',
      iconClass: 'pi pi-briefcase',
      link: '/facility/procurement_management/approval_workflows',
      module: 'purchase_orders'
    },
    {
      label: 'Inventory Requests',
      iconClass: 'pi pi-list',
      link: '/facility/procurement_management/approval_workflows',
      module: 'inventory_requests'
    },
  ];

  const handleCardClick = (tile) => {
    navigate(tile.link, { state: { moduleType: tile.module, moduleName: tile.label } });
  };

  return (
    <>
      <div className="row">
        <div className="col-sm-12">
          <div className="card">
            <div className="card-body">
              <div className="container">
                <div className="row">
                  {approvalTiles.map((tile, idx) => (
                    <div className="col-md-4 col-sm-6 mb-4" key={idx}>
                      <div
                        className="card h-100 text-center"
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleCardClick(tile)}
                      >
                        <div className="card-body d-flex flex-column justify-content-center align-items-center py-4">
                          {/* Icon */}
                          <span
                            className={`${tile.iconClass} mb-3`}
                            style={{ fontSize: '2.5rem', color: '#3f51b5' }}
                          ></span>
                          {/* Label */}
                          <h5 className="mt-2">{tile.label}</h5>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ApprovalWorkflowsTab;